import type { Audience, LeadState, StepId } from '../types'
import { InsurancesInput } from './InsurancesInput'
import { PostnrInput } from './PostnrInput'
import { AgeInput } from './AgeInput'
import { CurrentPriceInput } from './CurrentPriceInput'
import { KmInput } from './KmInput'
import { ClaimsInput } from './ClaimsInput'
import { PhoneInput } from './PhoneInput'

export interface StepInputProps {
  state: LeadState
  audience: Audience
  onSubmit: (updates: Partial<LeadState>) => void
}

interface Props extends StepInputProps {
  step: StepId
}

export function StepInput({ step, state, audience, onSubmit }: Props) {
  switch (step) {
    // 'welcome' rendereres som inline CTA-knap i MessageList (ikke i input-dock).
    // Widget.tsx skipper StepInput for welcome-step, så denne case nås aldrig.
    case 'welcome': return null
    case 'insurances': return <InsurancesInput state={state} audience={audience} onSubmit={onSubmit} />
    case 'postnr': return <PostnrInput state={state} audience={audience} onSubmit={onSubmit} />
    case 'age': return <AgeInput state={state} audience={audience} onSubmit={onSubmit} />
    case 'currentPrice': return <CurrentPriceInput state={state} audience={audience} onSubmit={onSubmit} />
    case 'km': return <KmInput state={state} audience={audience} onSubmit={onSubmit} />
    case 'claims': return <ClaimsInput state={state} audience={audience} onSubmit={onSubmit} />
    case 'phone': return <PhoneInput state={state} audience={audience} onSubmit={onSubmit} />
    default: return null
  }
}
